<mg-table [collectionComponent]="this" matSort stickyHeaders>

    <ng-container matColumnDef="foutmeldingExact" >
        <th id="foutmeldingExact" mat-header-cell *matHeaderCellDef mat-sort-header pd-size-2></th>
        <td mat-cell *matCellDef="let row" >
            <mat-icon class="red-icon" title="{{row.foutmeldingExact}}" *ngIf="row.foutmeldingExact != null">warning</mat-icon>
        </td>
    </ng-container>

    <ng-container matColumnDef="totaalbedrag_icon" >
        <th id="totaalbedrag_icon" mat-header-cell *matHeaderCellDef mat-sort-header pd-size-2></th>
        <td mat-cell *matCellDef="let row" ></td>
    </ng-container>

    <ng-container matColumnDef="factuur">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Factuur </th>
        <td mat-cell *matCellDef="let row"> {{row.id}} </td>
    </ng-container>

    <ng-container matColumnDef="nummer">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nummer </th>
        <td mat-cell *matCellDef="let row"> {{row.oldID}} </td>
    </ng-container>

    <ng-container matColumnDef="groep">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Groep </th>
        <td mat-cell *matCellDef="let row"> {{row.pakbon.project.projectgroep.afdeling}} </td>
    </ng-container>


    <ng-container matColumnDef="pakbon">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Pakbonnummer </th>
        <td mat-cell *matCellDef="let row"> {{row.pakbon.pakbonnummer}} </td>
    </ng-container>

    <ng-container matColumnDef="project">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Project </th>
        <td mat-cell *matCellDef="let row"> {{row.pakbon.project.code}} </td>
    </ng-container>

	<ng-container matColumnDef="naam1">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Naam </th>
        <td mat-cell *matCellDef="let row"> {{row.naam1}} </td>
    </ng-container>

    <ng-container matColumnDef="plaats">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Plaats </th>
        <td mat-cell *matCellDef="let row"> {{row.plaats}} </td>
    </ng-container>

	<ng-container matColumnDef="eMail">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
        <td mat-cell *matCellDef="let row"> {{row.eMail}} </td>
    </ng-container>

    <ng-container matColumnDef="omschrijving1">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Omschrijving </th>
        <td mat-cell *matCellDef="let row"> {{row.omschrijving1}} </td>
    </ng-container>

    <ng-container matColumnDef="factuurDatum">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Factuurdatum </th>
        <td mat-cell *matCellDef="let row"> {{row.factuurDatum | date}} </td>
    </ng-container>
	
    <ng-container matColumnDef="totaalbedrag">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Totaal<br>(zonder korting) </th>
        <td mat-cell *matCellDef="let row">
            <div *ngIf="row.totaalbedrag == 0" style="margin-left: 10px;"><mat-icon class="red-icon" title="Geen factuurbedrag" >credit_card_off</mat-icon></div>
            <div *ngIf="row.totaalbedrag != 0">€ {{row?.totaalbedrag?.toFixed(2) }} </div>
        </td>                       
    </ng-container>

    <ng-container matColumnDef="totaalArtikelen">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Artikelen </th>
        <td mat-cell *matCellDef="let row">€ {{row?.totaalArtikelen?.toFixed(2) }} </td>
    </ng-container>

    <ng-container matColumnDef="totaalKalibratieMetKorting">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Kalibratie<br>(met korting) </th>
        <td mat-cell *matCellDef="let row">€ {{row?.totaalKalibratieMetKorting?.toFixed(2) }} </td>
    </ng-container>

    <ng-container matColumnDef="isProForma">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> ProForma </th>
        <td mat-cell *matCellDef="let row"> <mat-icon *ngIf="row.isProForma">done</mat-icon></td>
    </ng-container>

    <ng-container matColumnDef="goedgekeurdOp">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Goedgekeurd </th>
        <td mat-cell *matCellDef="let row"> {{row.goedgekeurdOp | date}} </td>
    </ng-container>

    <ng-container matColumnDef="mailDatum">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Verzonden </th>
        <td mat-cell *matCellDef="let row"> {{row.mailDatum | date}} </td>
    </ng-container>

    <ng-container matColumnDef="naarExactOp">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Exact </th>
        <td mat-cell *matCellDef="let row"> {{row.naarExactOp | date}} </td>
    </ng-container>
</mg-table>
